import { render, staticRenderFns } from "./TransactionInfo.vue?vue&type=template&id=8ac3b5c0&scoped=true"
import script from "./TransactionInfo.vue?vue&type=script&lang=js"
export * from "./TransactionInfo.vue?vue&type=script&lang=js"
import style0 from "./TransactionInfo.vue?vue&type=style&index=0&id=8ac3b5c0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ac3b5c0",
  null
  
)

export default component.exports